var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M16 9.388V14.684A3.314 3.314 0 0 1 12.695 18H9.986a3.289 3.289 0 0 1-2.791-1.54c-1.357-2.143-3.072-5.733-3.09-5.769a.75.75 0 0 0-.065-.11c-.061-.088-.145-.38.228-.581.374-.202.57.021.628.103l1.54 2.63a.755.755 0 0 0 1.33-.492V4.094a.464.464 0 1 1 .925 0v4.887h1.51V2.464a.464.464 0 1 1 .927 0V8.982h1.51V4.094a.464.464 0 1 1 .926 0v6.11h1.51V6.538a.464.464 0 0 1 .925 0l.001 2.85zm-1.27-4.974c0-1.033-.825-1.873-1.84-1.873-.158 0-.31.027-.457.066C12.305 1.7 11.545 1 10.62 1c-.925 0-1.684.7-1.813 1.607a1.769 1.769 0 0 0-.458-.066c-1.013 0-1.838.84-1.838 1.873v5.766l-.773-.917a.685.685 0 0 0-.077-.08 1.602 1.602 0 0 0-2.189.087 1.66 1.66 0 0 0-.213 2.05c.208.441 1.697 3.568 2.94 5.559A4.451 4.451 0 0 0 9.987 19h2.524C14.986 19 17 16.95 17 14.43V6.725c0-1.033-.825-1.873-1.838-1.873-.15 0-.293.023-.432.059v-.497z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ff9334",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHold);
export default __webpack_public_path__ + "static/media/hold.f0bc4cacc2b3af2c4de40603970e5c11.svg";
export { ForwardRef as ReactComponent };